import { Routes, Route } from "react-router-dom";
import Documentation from "./Documentation";

const index = () => {
	return (
		<Routes>
			<Route index element={<Documentation />} />
		</Routes>
	);
};

export default index;
